import { ChangeDetectorRef, Directive, EventEmitter, Input } from '@angular/core';

import { BehaviorSubject, ReplaySubject } from 'rxjs';

import { FieldDefinition } from '@stylehaven/components';
import { CellOptions } from '../entities/cell-options/cell-options.entity';
import { Comparable } from '../entities/misc/comparable.interface';
import { Trackable } from '../entities/misc/trackable.interface';
import { isPlainClick } from '../helpers/plain-click.helper';

@Directive()
export abstract class BaseColumnComponent<T extends Trackable & Comparable, O extends CellOptions = CellOptions> {
    data$: ReplaySubject<T> = new ReplaySubject(1);
    fieldDefinition$: ReplaySubject<FieldDefinition> = new ReplaySubject(1);
    defaultValue$: BehaviorSubject<string> = new BehaviorSubject('-');
    enabled$: ReplaySubject<boolean> = new ReplaySubject(1);
    options$: ReplaySubject<O> = new ReplaySubject(1);
    overviewId$: BehaviorSubject<string | undefined> = new BehaviorSubject<string | undefined>(undefined);

    rowNavigation: EventEmitter<T> = new EventEmitter<T>();

    constructor(protected cd: ChangeDetectorRef) {}

    linkClicked(record: T, event: MouseEvent): void {
        if (!isPlainClick(event)) {
            return;
        }

        this.rowNavigation.emit(record);
    }

    @Input()
    set data(data: T) {
        this.data$.next(data);
        this.cd.detectChanges();
    }

    @Input()
    set fieldDefinition(fieldDef: FieldDefinition | undefined) {
        if (fieldDef) {
            this.fieldDefinition$.next(fieldDef);
            this.cd.detectChanges();
        }
    }

    @Input()
    set defaultValue(defaultValue: string | undefined) {
        if (defaultValue) {
            this.defaultValue$.next(defaultValue);
            this.cd.detectChanges();
        }
    }

    @Input()
    set enabled(enabled: boolean | undefined) {
        if (enabled) {
            this.enabled$.next(enabled);
            this.cd.detectChanges();
        }
    }

    @Input()
    set options(options: O | undefined) {
        if (options) {
            this.options$.next(options);
        }
    }

    @Input()
    set overviewId(overviewId: string | undefined) {
        if (overviewId) {
            this.overviewId$.next(overviewId);
            this.cd.detectChanges();
        }
    }
}
